import { LoanCommands } from '@skynet/loans';
import { StrikePricesCommands } from '@skynet/data-strike-prices';
import { ExchangeLiquidityCommands } from '@skynet/data-loan-exchanges';
import { LoanFundsCommands } from 'src/store/loans/funds/types';
import { LoanProfitCommands } from 'src/store/loans/profit/types';
import { LoanOverviewCommands } from '@skynet/data-loan-overview';
import { AdminPanelCommands } from 'src/store/retainers/admin-panel/types';
import { TransactionCommands } from 'src/store/shared/transactions/types';
import { AccountCommands } from '@skynet/data-shared-accounts';
import { LoanKpiCommands } from 'src/store/loans/kpi/slice';
import { RetainerKpiCommands } from 'src/store/retainers/kpi/slice';

export const Commands = {
  Loans: LoanCommands.Loans,
  Overview: LoanCommands.Overview,
  // Pairs: LoanCommands.Pairs,
  Balances: LoanCommands.Balances,
  BalanceHistory: LoanCommands.BalanceHistory,
  LoanStrikes: StrikePricesCommands.LoanStrikes,
  LoanKPI: LoanKpiCommands.KPI,
  RetainerKPI: RetainerKpiCommands.KPI,
  LoanExchanges: ExchangeLiquidityCommands.LoanExchanges,
  LoanFunds: LoanFundsCommands.LoanFunds,
  LoanProfit: LoanProfitCommands.LoanProfit,
  LoanOverview: LoanOverviewCommands.LoanOverview,
  AdminPanel: AdminPanelCommands.AdminPanel,
  Transactions: TransactionCommands.Transactions,
  GetTransactions: TransactionCommands.GetTransactions,
  Accounts: AccountCommands.Accounts,
};
